var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddPinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0704 25.7102C42.0704 36.5628 33.0999 45.3553 22.0276 45.3553C10.9553 45.3553 1.99997 36.5628 1.99997 25.7102C1.99997 14.8577 10.9705 6.08008 22.0428 6.08008",
    stroke: "#F85663",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3643 1.99902V17.2386",
    stroke: "#F85663",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 9.61816H45.7299",
    stroke: "#F85663",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6735 28.7227C29.4712 28.7227 29.999 29.5783 29.7044 30.3691C28.4894 33.5843 25.507 35.853 22.0337 35.853C18.5604 35.853 15.578 33.5843 14.3629 30.3691C14.0684 29.5913 14.5961 28.7227 15.3939 28.7227H28.6857H28.6735Z",
    fill: "#F85663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9209 22.9907C17.3486 22.9907 18.506 21.7933 18.506 20.3161C18.506 18.839 17.3486 17.6416 15.9209 17.6416C14.4932 17.6416 13.3358 18.839 13.3358 20.3161C13.3358 21.7933 14.4932 22.9907 15.9209 22.9907Z",
    fill: "#F85663",
    stroke: "#F85663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1518 22.9907C29.5795 22.9907 30.7369 21.7933 30.7369 20.3161C30.7369 18.839 29.5795 17.6416 28.1518 17.6416C26.7241 17.6416 25.5667 18.839 25.5667 20.3161C25.5667 21.7933 26.7241 22.9907 28.1518 22.9907Z",
    fill: "#F85663",
    stroke: "#F85663"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPinkIcon);
export default __webpack_public_path__ + "static/media/add-pink-icon.6adf8383.svg";
export { ForwardRef as ReactComponent };